const FiltersConstants = require('../../constants/FiltersConstants');

const { CATEGORIES } = FiltersConstants;

const STAY_TYPE = {
    HOTEL: 'hotel',
    APARTMENT: 'apartment',
    APART_HOTEL: 'apart_hotel',
};

// Hotel entities key the flags by filter label; the raw search hotel keeps the hotel matrix lowercase keys.
const getCategoryFlag = (categoryFlags, label) => categoryFlags[label] ?? categoryFlags[label.toLowerCase()];

// The hotel matrix sets both flags only for apart-hotels; "other" also covers hotels with no known category.
const getStayType = (categoryFlags) => {
    if (!categoryFlags || typeof categoryFlags !== 'object' || Array.isArray(categoryFlags)) {
        return null;
    }

    const isHotel = getCategoryFlag(categoryFlags, CATEGORIES.HOTEL) === true;
    const isApartment = getCategoryFlag(categoryFlags, CATEGORIES.APARTMENT) === true;
    if (isHotel && isApartment) {
        return STAY_TYPE.APART_HOTEL;
    }
    if (isHotel) {
        return STAY_TYPE.HOTEL;
    }
    if (isApartment) {
        return STAY_TYPE.APARTMENT;
    }

    return null;
};

module.exports = {
    STAY_TYPE,
    getStayType,
};
